import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export function DigestToggle() {
  const [on, setOn] = useState(null);
  useEffect(() => { api.get("/account/digest").then((r) => setOn(r.data.enabled)).catch(() => {}); }, []);
  const change = async (v) => {
    setOn(v);
    try { await api.put("/account/digest", { enabled: v }); toast.success(v ? "Weekly digest turned on" : "Weekly digest turned off"); }
    catch (e) { setOn(!v); toast.error(errMsg(e)); }
  };
  if (on === null) return null;
  return (
    <div className="bg-[#0F172A]/80 border border-slate-800 rounded-lg p-5 max-w-md flex items-center gap-4" data-testid="digest-toggle-card">
      <Mail className="h-5 w-5 text-[#03AB9E] shrink-0" />
      <div className="flex-1">
        <p className="font-semibold text-sm">Weekly insights digest</p>
        <p className="text-xs text-slate-400">Every Monday, the refreshed AI insights for the products you subscribe to.</p>
      </div>
      <Switch checked={on} onCheckedChange={change} data-testid="digest-toggle" />
    </div>
  );
}
